import { Link } from 'react-router-dom'
import { Box, Button, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { TrendingFlat } from '@mui/icons-material'
import BlockFull2Col from 'src/components/Common/BlockFull2Col'
import allowContent from 'src/customHooks/allowContent'

export default function SemiAnnualSale() {
  const renderable = allowContent(['us'], false)
  return (
    <BlockFull2Col inverted bgColor='#1f193c' image='https://meteor.stullercloud.com/das/136872911?wid=1400'>
      <Stack mt={-2} gap={2} alignItems='flex-start'>
        <Box
          component='img'
          sx={{ height: { xs: 32, sm: 40 } }}
          src='https://meteor.stullercloud.com/das/136871401?fmt=smart-alpha&hei=80'
        />
        <Typography variant='h1' sx={{ color: '#f6da89', textTransform: 'uppercase', fontWeight: 800 }}>
          <FormattedMessage id='home.banner.semiAnnualSale.title' />
        </Typography>
        {renderable ? (
          <Typography>
            Save up to $1,500 when you purchase software, certifications, and annual membership together.
            <span> </span>
            <Link to='/sales'>Contact Sales</Link> to purchase your package.
          </Typography>
        ) : null}
        <Typography>
          <FormattedMessage id='home.banner.semiAnnualSale.date' />
        </Typography>
        <Button
          sx={{ mt: { xs: 1, sm: 2 } }}
          size='large'
          variant='contained'
          component={Link}
          to='/store'
          endIcon={<TrendingFlat />}
        >
          <FormattedMessage id='common.buyNow' />
        </Button>
      </Stack>
    </BlockFull2Col>
  )
}
